import styles from './SocialBar.module.css'
import googleIcon from '@/assets/brand/social-google-icon.svg'
import { cn } from '@/lib/utils'

interface SocialBarProps {
  className?: string
  onGoogleClick?: () => void
  label?: string
}

export function SocialBar({ className, onGoogleClick, label = 'Or sign in with' }: SocialBarProps) {
  return (
    <div className={cn(styles.root, className)}>
      <div className={styles.icons}>
        <button
          type="button"
          className={styles.iconButton}
          onClick={onGoogleClick}
          aria-label="Continue with Google"
        >
          <img src={googleIcon} alt="" className={styles.iconImage} />
        </button>
      </div>
      <p className={styles.label}>{label}</p>
    </div>
  )
}
